var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form-stepper__button-next styled-button",class:{ 't-99': _vm.isActive },attrs:{"type":"button","aria-disabled":!_vm.isActive,"disabled":!_vm.isActive},on:{"click":_vm.stepperContext.advanceStep}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }